<template>
  <div class="tw-flex tw-gap-4">
    <div class="tw-flex-1 tw-min-w-0">
      <ConnectionsCard
        :is-m365-connected="isM365Connected"
        :is-ndr-configured="isNdrConfigured"
        :is-journal-rule-configured="isJournalRuleConfigured"
        :show-ndr-journal-steps="canShowNdrAndJournal"
      />
      <M365ConnectionCard
        :is-connected="isM365Connected"
        :last-update="formattedM365LastUpdate"
        :is-request-pending="isRequestPending"
        :pending-app="pendingM365App"
        :connected-app="connectedAzureApp"
        :primary-connect-app="primaryConnectApp"
        :needs-app-update="needsAppUpdate"
        :update-status="m365UpdateStatus"
        @connect="onConnectM365"
        @connect-old="onConnectOldAppM365"
        @update="onUpdateM365Permissions"
      />
      <ndrConnectionCardIndex
        v-if="canShowNdrAndJournal"
        :is-connected="isNdrConfigured"
        :is-m365-connected="isM365Connected"
        :last-update="formattedNdrLastUpdate"
        :is-request-pending="isNdrRequestPending"
        :customer-name="selectedCustomer?.name || ''"
        :has-error="ndrError"
        :error-message="ndrErrorMessage"
        @connect="onConfigureNdr"
      />
      <journalingRuleConnectionCardIndex
        v-if="canShowNdrAndJournal"
        :is-connected="isJournalRuleConfigured"
        :is-m365-connected="isM365Connected"
        :last-update="formattedJournalRuleLastUpdate"
        :is-request-pending="isJournalRuleRequestPending"
        :customer-name="selectedCustomer?.name || ''"
        :has-error="journalRuleError"
        :error-message="journalRuleErrorMessage"
        :is-ndr-configured="isNdrConfigured"
        @connect="onConfigureJournalRule"
      />
    </div>
    <div class="tw-w-[348px] tw-shrink-0">
      <ConnectionsSidebar
        :is-phish-service-active="isPhishServiceActive"
        :is-phs-service-active="isPhsServiceActive"
        :is-sat-service-active="isSatServiceActive"
      />
    </div>
  </div>
  <connectionSuccessModalIndex
    :visible="showSetupComplete"
    @close="showSetupComplete = false"
  />
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import M365ConnectionCard from "./m365-connection-card/m365-connection-card.index.vue";
import ConnectionsCard from "./connections-card/connections-card.index.vue";
import ConnectionsSidebar from "./connections-sidebar/connections-sidebar.index.vue";
import ndrConnectionCardIndex from "./ndr-connection-card/ndr-connection-card.index.vue";
import journalingRuleConnectionCardIndex from "./journaling-rule-connection-card/journaling-rule-connection-card.index.vue";
import { useConnectionsState } from "./connections-container.state";
import connectionSuccessModalIndex from "./connection-success-modal/connection-success-modal.index.vue";

const {
  isRequestPending,
  pendingM365App,
  needsAppUpdate,
  primaryConnectApp,
  canShowNdrAndJournal,
  connectedAzureApp,
  m365UpdateStatus,
  isNdrRequestPending,
  isJournalRuleRequestPending,
  isM365Connected,
  isNdrConfigured,
  isJournalRuleConfigured,
  isPhishServiceActive,
  formattedM365LastUpdate,
  formattedNdrLastUpdate,
  formattedJournalRuleLastUpdate,
  selectedCustomer,
  onConnectM365,
  onConnectOldAppM365,
  onUpdateM365Permissions,
  onConfigureNdr,
  onConfigureJournalRule,
  ndrError,
  ndrErrorMessage,
  journalRuleError,
  journalRuleErrorMessage,
  initialLoadComplete,
  isSatServiceActive,
  isPhsServiceActive,
} = useConnectionsState();

const showSetupComplete = ref(false);

watch(
  () =>
    isM365Connected.value &&
    isNdrConfigured.value &&
    isJournalRuleConfigured.value,
  (newVal, oldVal) => {
    if (newVal && oldVal === false && initialLoadComplete.value) {
      showSetupComplete.value = true;
    }
  },
);
</script>
